module.exports = __webpack_public_path__ + "img/news-1-1.1ca7d7ad.png";